export default __webpack_public_path__ + "static/media/steve-jobs.b8076fbf.jpeg";